
import Login from './components/Login.vue'
import Register from './components/Register.vue'
import ForgotPw from './components/ForgotPw.vue'
import DesignAssets from './components/DesignAssets.vue'
import ProjectsOverview from './components/ProjectsOverview.vue'
import JobsOverview from './components/JobsOverview.vue'
import CalcsOverview from './components/CalcsOverview.vue'
import Calculation from './components/Calculation.vue'
import Logout from './components/Logout.vue'
import LogoutSession from './components/LogoutSession.vue';
import addInfo from './components/addInfo.vue';

import ContractSign from './components/ContractSign.vue'
import { i18n } from "./main.js";

export default [
    { 
        path: '/:lang', 
        component: Login,
        beforeEnter(to, from, next) {
            const lang = to.params.lang;
            if (!["en", "de"].includes(lang)) return next("de");
            if (i18n.locale !== lang) {
              i18n.locale = lang;
            }
            return next();
          },

    },
    { 
      path: '/:lang/calculation/:calculationid', 
      component: Calculation,
      beforeEnter(to, from, next) {
          const lang = to.params.lang;
          if (!["en", "de"].includes(lang)) return next("de");
          if (i18n.locale !== lang) {
            i18n.locale = lang;
          }
          return next();
        },

  },
    { 
        path: '/:lang/register', 
        component: Register,
        beforeEnter(to, from, next) {
            const lang = to.params.lang;
            if (!["en", "de"].includes(lang)) return next("de");
            if (i18n.locale !== lang) {
              i18n.locale = lang;
            }
            return next();
          },

    },
    { 
        path: '/:lang/forgotpw', 
        component: ForgotPw,
        beforeEnter(to, from, next) {
            const lang = to.params.lang;
            if (!["en", "de"].includes(lang)) return next("de");
            if (i18n.locale !== lang) {
              i18n.locale = lang;
            }
            return next();
          },

    },
    { 
      path: '/:lang/design', 
      component: DesignAssets,
      beforeEnter(to, from, next) {
          const lang = to.params.lang;
          if (!["en", "de"].includes(lang)) return next("de");
          if (i18n.locale !== lang) {
            i18n.locale = lang;
          }
          return next();
        },

  },
  { 
    path: '/:lang/projects', 
    component: ProjectsOverview,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },

  { 
    path: '/:lang/jobs/:projectid', 
    component: JobsOverview,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
  { 
    path: '/:lang/calculations/:projectsid', 
    component: CalcsOverview,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
  { 
    path: '/:lang/contractsign', 
    component: ContractSign,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
  { 
    path: '/:lang/logout', 
    component: Logout,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
  { 
    path: '/:lang/logout-session', 
    component: LogoutSession,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
  { 
    path: '/:lang/addinfo', 
    component: addInfo,
    beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
  },
    {
      path: "*",
      redirect: "/de"
    }
    
]